import { useTranslation } from 'next-i18next';
import styles from '@features/showrooms/sections/ShowroomSection/Components/ServiceInfo/ServiceInfo.styles';
import Icon from '@components/icons/Icon';
import sanitizeHtml from '@utils/sanitizeHtml';
import Heading from '@components/Heading/Heading';
import { IPointOfServices } from '@features/checkout/typescript';
type PropsType = {
  services: IPointOfServices[];
};
const ServiceInfo = ({
  services
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const handleSanitizeHtml = (key: string) => {
    const html = t(key);
    return sanitizeHtml(html || '');
  };
  const hasService = (service: string): boolean => services.map(item => item.code).includes(service);
  return <div sx={styles.container}>
      <Heading h={2} size={40} uppercase mobile>
        {t('showroomServices')}
      </Heading>
      <div sx={styles.servicesContainer}>
        {hasService('HAS_VOXBOX') && hasService('HAS_VOXBOX_DESKTOP') && <div sx={styles.item}>
            <Icon icon="CubicMonitor" size="60px" />
            <p dangerouslySetInnerHTML={handleSanitizeHtml('showroomAdvantages.freeInteriorDesign')} />
          </div>}
        {hasService('HAS_VOXBOX_VR') && <div sx={styles.item}>
            <Icon icon="DesignInVoxboxVr" size="60px" />
            <p dangerouslySetInnerHTML={handleSanitizeHtml('showroomAdvantages.designInVoxboxVr')} />
          </div>}
        {hasService('MATERIAL_LIBRARY') && <div sx={styles.item}>
            <Icon icon="MaterialLibrary" size="60px" />
            <p dangerouslySetInnerHTML={handleSanitizeHtml('showroomAdvantages.materialLibrary')} />
          </div>}
        {hasService('DESINGER_ZONE') && <div sx={styles.item}>
            <Icon icon="ArchitectsZone" size="60px" />
            <p dangerouslySetInnerHTML={handleSanitizeHtml('showroomAdvantages.architectsZone')} />
          </div>}
        {hasService('STYLISTS_SUPPORT') && <div sx={styles.item}>
            <Icon icon="Friendly" size="60px" />
            <p dangerouslySetInnerHTML={handleSanitizeHtml('showroomAdvantages.stylisticSupport')} />
          </div>}
        {hasService('DESIGN_ADVICE_DIP') && <div sx={styles.item}>
            <Icon icon="VoxboxMonitor" size="60px" />
            <p dangerouslySetInnerHTML={handleSanitizeHtml('showroomAdvantages.designTechnicalConsulting')} />
          </div>}
        {hasService('FREE_MEASUREMENT') && <div sx={styles.item}>
            <Icon icon="Resize" size="60px" />
            <p dangerouslySetInnerHTML={handleSanitizeHtml('showroomAdvantages.measurement')} />
          </div>}
        {hasService('CERTIFIED_ASSEMBLY_TEAMS') && <div sx={styles.item}>
            <Icon icon="Safe" size="60px" />
            <p dangerouslySetInnerHTML={handleSanitizeHtml('showroomAdvantages.certifiedTeams')} />
          </div>}
        {hasService('DELIVERY') && <div sx={styles.item}>
            <Icon icon="TruckNarrow" size="60px" />
            <p dangerouslySetInnerHTML={handleSanitizeHtml('showroomAdvantages.transport')} />
          </div>}
        {hasService('INSTALLMENTS') && <div sx={styles.item}>
            <Icon icon="Percent" size="60px" />
            <p dangerouslySetInnerHTML={handleSanitizeHtml('showroomAdvantages.installmentsales')} />
          </div>}
      </div>
    </div>;
};
export default ServiceInfo;